


import {
  Breadcrumbs,
  Container,
  Grid,
  Link,
  Tooltip,
  Button,
  Divider,
} from '@mui/material';
import { useLocation, useParams, useNavigate } from 'react-router-dom';
import EdPaused1MainPage from './EdPaused1MainPage';


export default function EdPaused1() {
  const { id, sitename } = useParams();
 
  
 const location = useLocation();
  const navigate = useNavigate();
 const siteName = location?.state?.location || sitename

  const handleBackToPreviousPage = () => {
    navigate(-1);
  };

  return (
    <Container maxWidth={false}>
      <Grid container alignItems="center" justifyContent="space-between" sx={{ py: 2 }}>
        <Grid item>
          <Breadcrumbs aria-label="breadcrumb">
            <Link underline="hover" color="inherit" href="/dashboard/dashboard">
              Edge Device Management
            </Link>
            <Link underline="hover" color="inherit" href={`/dashboard/edgedevice-management/ed-paused/${id}`}>
              Device Status
            </Link>
            <Link underline="hover" color="inherit" href="#">
              {siteName}
            </Link>
          </Breadcrumbs>
        </Grid>
        <Grid item>
          <Tooltip title="Go back to the previous page">
            <Button
              variant="outlined"
              onClick={handleBackToPreviousPage}
              sx={{
                color: '#1976d2',
                textTransform: 'none',
                fontWeight: 'bold',
                borderRadius: '8px',
                padding: '6px 16px',
                marginTop: '-20px',
              }}
            >
              ← Back
            </Button>
          </Tooltip>
        </Grid>
      </Grid>

      <Divider />

      <Grid container item xs={12} sx={{ py: 2 }}>
        <EdPaused1MainPage />
      </Grid>
    </Container>
  );
}
